import PhoneInputMasked from '@/components/PhoneInputMasked';
import { cn } from '@/lib/utils';
import { inputClassName } from '@/components/ui/input';

export default function ClubPhoneInput({ className, ...props }) {
    return <PhoneInputMasked className={cn(inputClassName, className)} {...props} />;
}
